import React, { useEffect } from 'react';
import { Button } from 'geniebook-ui/dist';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
  errorAtom,
  selectedSubjectIdAtom,
  subscriptionInvoiceIdAtom,
  successAtom,
} from '@components/subscription/store/SubscriptionAtoms';
import { useInvoiceStatus } from '@components/subscription/hooks/InvoiceStatusHook';
import { Player } from '@lottiefiles/react-lottie-player';
import button_loading from '@assets/animation/loading-dots.json';
import {
  hintAddOnQueryAtom,
  requestPaymentAtom,
} from '@components/subscription/store/HintPaymentAtoms';

const SubscribeHintButton = () => {
  const setSuccess = useSetAtom(successAtom);
  const setError = useSetAtom(errorAtom);
  const [invoiceId, setInvoiceId] = useAtom(subscriptionInvoiceIdAtom);
  const subjectId = useAtomValue(selectedSubjectIdAtom);
  const hintDetailQuery = useAtomValue(hintAddOnQueryAtom);
  const requestPaymentMutation = useAtomValue(requestPaymentAtom);

  const invoiceStatus = useInvoiceStatus({
    subject_id: Number(subjectId),
    subscription_invoice_id: Number(invoiceId),
  });

  async function handleSubscribe() {
    if (invoiceStatus === 'in-progress' || requestPaymentMutation.isPending) {
      return;
    }

    const { data } = await requestPaymentMutation.mutateAsync();

    if (!data.error) {
      window.open(data.data.payment_link, '_blank');
      setInvoiceId(data.data.subscription_invoice_id);
    } else {
      setError(data.error_msg);
    }
  }

  useEffect(() => {
    if (invoiceStatus === 'success') {
      hintDetailQuery.refetch().finally(() => {
        setSuccess('Hooray! Your unlimited hints are now available.');
      });
    }
    if (invoiceStatus === 'success' || invoiceStatus === 'error') {
      setInvoiceId(null);
    }
  }, [invoiceStatus]);

  useEffect(() => {
    return () => {
      setInvoiceId(null);
    };
  }, []);

  return (
    <Button
      className={
        'w-full !max-w-full !font-extrabold hover:transform hover:!scale-[1.01]'
      }
      onClick={handleSubscribe}
    >
      {invoiceStatus === 'in-progress' || requestPaymentMutation.isPending ? (
        <Player
          autoplay={true}
          src={button_loading}
          loop={true}
          style={{ height: '32px' }}
        />
      ) : (
        'Purchase'
      )}
    </Button>
  );
};

export default SubscribeHintButton;
